import { Link } from 'react-router-dom';
import { IconInfoCircle } from '@tabler/icons-react';
import { API_TARGET, USE_MOCKS } from '../../api/config';
import AppFooter from './AppFooter';
import BottomNav from './BottomNav';
import GuestTopNav from './GuestTopNav';
import TopNav from './TopNav';
import LogoBrand from '../ui/LogoBrand';
import './AppLayout.scss';

const showApiBadge = process.env.NODE_ENV === 'development' && !USE_MOCKS;

export default function AppLayout({
    children,
    showHeader = true,
    showBottomNav = false,
    showTopNav = false,
    showGuestTopNav = false,
    withNavPadding = false,
    bare = false,
    showFooter = true,
}) {
    const layoutClass = [
        'app-layout',
        withNavPadding && 'app-layout--with-nav',
        bare && 'app-layout--bare',
    ].filter(Boolean).join(' ');

    return (
        <div className="app-shell">
            {showApiBadge && (
                <div className="app-layout__api-badge" aria-hidden="true">
                    API: {API_TARGET}
                </div>
            )}
            <div className={layoutClass}>
                {showTopNav && <TopNav />}
                {showGuestTopNav && <GuestTopNav />}

                {showHeader && !showTopNav && !showGuestTopNav && (
                    <header className="app-layout__header">
                        <div className="header-content">
                            <LogoBrand variant="hero" as="h1" />
                            <Link
                                to="/links"
                                className="info-button"
                                aria-label="Информация"
                            >
                                <IconInfoCircle size={20} stroke={1.5} />
                            </Link>
                        </div>
                        <p className="under-logo">
                            Личный кабинет — теперь в браузере
                        </p>
                    </header>
                )}

                <main className="app-layout__main">{children}</main>

                {showFooter && <AppFooter />}

                {showBottomNav && <BottomNav />}
            </div>
        </div>
    );
}
